import type { FC } from "react";
import { useMemo } from "react";
import { setCookie } from "nookies";
import { usePathname } from "next/navigation";
import { cn } from "class-merge";
import { Select } from "~components/select";
import { RegionEnum } from "~constants/etc";
import WorldOutlined from "../../../../packages/icons-react/src/icons/WorldOutlined";

export const languageToRegionMap = {
  en: RegionEnum.US,
  th: RegionEnum.TH,
  vi: RegionEnum.VN,
  cn: RegionEnum.CN,
};

const SelectLanguageWidget: FC<{
  locale: string;
  className?: string;
  optionClassName?: string;
}> = ({ locale, className }) => {
  const pathname = usePathname();

  const regionCodeOptions = useMemo(() => {
    return ["th", "en", "vi", "cn"].map((lang) => {
      const region = languageToRegionMap[lang];
      return {
        selectedValue: <div className="text-white text-base font-semibold uppercase flex items-center gap-2"><WorldOutlined className="text-2xl" /> {region}</div>,
        label: <div className="text-white text-base font-semibold uppercase">{region}</div>,
        value: lang,
      };
    });
  }, []);

  const handleSelectLanguage = ({ value }): void => {
    const path = pathname.slice(3);
    setCookie(undefined, "NEXT_LOCALE", value, { path: "/" });
    window.location.href = `/${value}${path}`;
  };

  return (
    <div
      className={cn(
        "w-[110px] h-[50px] xl:h-[60px] rounded-[15px] bg-secondary/30 flex items-center",
        className,
      )}
    >
      <Select
        className="text-select-primary h-[40px] w-full rounded-lg border-none outline-none"
        defaultSelectedOption={locale}
        onSelect={handleSelectLanguage}
        options={regionCodeOptions}
      />
    </div>
  );
};

export default SelectLanguageWidget;
